import { PromoComponent } from '@/mainComponent/PromoComponent';
import { IAchievement } from '@/mainComponent/store/interfaces/IAchievement';
import { ACTION } from '@/store/ACTION';
import { Utils } from '@/utils/Utils';

class PopupsFreeSpinsController {
  protected allowed(): boolean {
    const isStartedGames: boolean =
      this.store.gameData.freeSpinsGame.isPlaying() ||
      this.store.gameData.freeSpinsGame.isStarted() ||
      this.store.gameData.bonusGame.isPlaying() ||
      this.store.gameData.bonusGame.isStarted();
    return (
      this.store.promo.hasPromoApp() &&
      this.store.promo.isStartGameForPromo &&
      this.store.promo.isAchievement &&
      !isStartedGames &&
      !this.store.promo.isFreeRounds
    );
  }

  execution(): void {
    if (!this.allowed()) return;

    const { isFreeSpinsPopup, isPopupFreeSpinsOtherGame, isPopupFinishGame, achievement } = this.store.promo;

    const {
      reward: { wins },
      currencyDecimals,
      currencyCode
    } = <IAchievement>achievement;

    switch (true) {
      case isFreeSpinsPopup && !this.store.promo.isPopupOnesAchievement:
        promoApp.eventEmitter.emit(ACTION.SHOW_FREESPIN_WIN);
        game.emit(PromoComponent.events.START_FREESPINS);
        game.emit('ReelsetComponent.SET_WAIT_SPIN_SKIP', { status: true });
        this.store.promo.isShowPopupFreeSpinsAchievement = true;
        break;
      case isPopupFreeSpinsOtherGame && !this.store.promo.isPopupOtherGameOnesAchievement:
        promoApp.eventEmitter.emit(ACTION.SHOW_FREESPIN_WIN_OTHER_GAME);
        game.emit(PromoComponent.events.START_FREESPINS_OTHER_GAME);
        game.emit('ReelsetComponent.SET_WAIT_SPIN_SKIP', { status: true });
        this.store.promo.isShowPopupFreeSpinsOtherGameAchievement = true;
        break;
      case isPopupFinishGame:
        promoApp.eventEmitter.emit(ACTION.SHOW_FREESPIN_FINISH, {
          totalWin: Utils.centsToMoneyStr(wins, currencyDecimals, currencyCode)
        });
        this.store.promo.resetAchievement();
        game.emit(PromoComponent.events.END_ACHIEVEMENT);
    }
  }

  get store() {
    return game.store;
  }
}

export { PopupsFreeSpinsController };
